export default {"src":"/_next/static/media/2.a16a7a10.svg","height":82,"width":76,"blurWidth":0,"blurHeight":0};